import React from 'react';
import PropTypes from 'prop-types';

import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField
} from '@mui/material';

import {
  DescriptionOutlined,
  KeyboardArrowDownOutlined
} from '@mui/icons-material';

import DiagnosisSummary from '../Summaries/DiagnosisSummary';

import {
  menuProps,
  multitextFieldSx,
  textFieldSx
} from '../../../../../Common/components/Styles/InputStyles';

import { providerOptions } from './SoapEntryData';

import {
  assessmentButtonStyles,
  assessmentPlanActionsSx,
  sectionSx,
  templateButtonIconSx
} from './SoapEntryStyles';

const AssessmentPlanSection = ({
  value,
  diagnoses,
  route,
  onChange,
  onOpenDiagnosis,
  onOpenTemplate,
  onRouteChange
}) => {
  return (
    <Box sx={sectionSx}>
      <Stack spacing={3}>
        <Box>
          <Box sx={assessmentPlanActionsSx}>
            <Button
              variant="outlined"
              size="small"
              onClick={onOpenDiagnosis}
              sx={{
                ...assessmentButtonStyles.common,
                ...assessmentButtonStyles.rx
              }}>
              ICD-10 &amp; Diagnosis
            </Button>

            <Button
              color="primary"
              variant="outlined"
              size="small"
              onClick={onOpenTemplate}>
              <DescriptionOutlined sx={templateButtonIconSx} />

              AP Template
            </Button>
          </Box>

          <TextField
            fullWidth
            multiline
            minRows={4}
            label="Assessment Plan"
            value={value}
            onChange={event => onChange(event.target.value)}
            sx={multitextFieldSx}
          />

          <DiagnosisSummary
            diagnoses={diagnoses}
            onEdit={onOpenDiagnosis}
          />
        </Box>

        <FormControl
          fullWidth
          size="small"
          sx={textFieldSx}>
          <InputLabel id="provider-route-label">
            Route to Provider
          </InputLabel>

          <Select
            labelId="provider-route-label"
            value={route}
            label="Route to Provider"
            onChange={onRouteChange}
            IconComponent={KeyboardArrowDownOutlined}
            MenuProps={menuProps}>
            {providerOptions.map(provider => (
              <MenuItem
                key={provider.value}
                value={provider.value}>
                {provider.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Stack>
    </Box>
  );
};

AssessmentPlanSection.propTypes = {
  value: PropTypes.string,
  diagnoses: PropTypes.array,
  route: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  onChange: PropTypes.func.isRequired,
  onOpenDiagnosis: PropTypes.func.isRequired,
  onOpenTemplate: PropTypes.func.isRequired,
  onRouteChange: PropTypes.func.isRequired
};

export default AssessmentPlanSection;